import { Props, FormFieldProps } from './interfaces';
import React, { FC, useCallback, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { I18n } from 'react-redux-i18n';
import Button from '@ui/Button';
import { Col, Form, InputNumber, Row } from 'antd';
import { getSchema } from './schema';
import { yupResolver } from '@hookform/resolvers/yup';

const STEPS = [0, 10, 20, 30, 40];

export const Price: FC<Props> = ({ config, onSubmit }) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    defaultValues: config,
    resolver: yupResolver(getSchema()),
  });

  useEffect(() => {
    reset(config);
  }, [config, reset]);

  const handleSubmitSaveChanges = useCallback(() => {
    handleSubmit(onSubmit)();
  }, [handleSubmit, onSubmit]);

  const FormField: FC<FormFieldProps> = ({ name, label }) => {
    const error = errors[name];
    return (
      <Form.Item
        help={error && error['message']}
        validateStatus={errors[name] ? 'error' : 'success'}
        label={label}
      >
        <Controller
          name={name}
          control={control}
          defaultValue={0}
          render={({ field: { ref, ...props } }) => (
            <InputNumber min={0} {...props} />
          )}
        />
      </Form.Item>
    );
  };

  return (
    <>
      <form>
        <Row>
          <Col span={24}>
            <Form.Item label={I18n.t('admin.salary.ru')}>
              <Row>
                {STEPS.map(step => (
                  <Col span={4} key={step}>
                    <FormField name={`ru.${step}`} label={step.toString()} />
                  </Col>
                ))}
              </Row>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item label={I18n.t('admin.salary.en')}>
              <Row>
                {STEPS.map(step => (
                  <Col span={4} key={step}>
                    <FormField name={`en.${step}`} label={step.toString()} />
                  </Col>
                ))}
              </Row>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            disabled={!isDirty}
            color="green"
            size="big"
            onClick={handleSubmitSaveChanges}
          >
            {I18n.t('admin.salary.recalculate')}
          </Button>
        </Form.Item>
      </form>
    </>
  );
};
